import { normalize } from 'normalizr'
import { Schemas } from 'redux-modules/schema'
import { updateEntities, deleteEntity } from 'redux-modules/entity'
import api from 'api'

const FETCH_REQUEST = 'realhub/providerOrderCode/FETCH_REQUEST'
const FETCH_SUCCESS = 'realhub/providerOrderCode/FETCH_SUCCESS'
const FETCH_FAILURE = 'realhub/providerOrderCode/FETCH_FAILURE'

const CREATE_REQUEST = 'realhub/providerOrderCode/CREATE_REQUEST'
const CREATE_SUCCESS = 'realhub/providerOrderCode/CREATE_SUCCESS'
const CREATE_FAILURE = 'realhub/providerOrderCode/CREATE_FAILURE'

const DELETE_REQUEST = 'realhub/providerOrderCode/DELETE_REQUEST'
const DELETE_SUCCESS = 'realhub/providerOrderCode/DELETE_SUCCESS'
const DELETE_FAILURE = 'realhub/providerOrderCode/DELETE_FAILURE'

// Initial State
const initialState = {
  result: [],
  creating: false,
  loaded: false,
  loading: false,
  deleting: false,
  errors: [],
}

// Actions
export function fetchRequest(){
  return {
    type: FETCH_REQUEST,
  }
}

export function fetchSuccess(){
  return {
    type: FETCH_SUCCESS,
  }
}

export function fetchFailure(errors = []){
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

export function createRequest(){
  return {
    type: CREATE_REQUEST,
  }
}

export function createSuccess(){
  return {
    type: CREATE_SUCCESS,
  }
}

export function createFailure(errors = []){
  return {
    type: CREATE_FAILURE,
    errors,
  }
}

export function deleteRequest(){
  return {
    type: DELETE_REQUEST,
  }
}

export function deleteSuccess(payload = {}){
  return {
    type: DELETE_SUCCESS,
    result: payload.result,
  }
}

export function deleteFailure(errors = []){
  return {
    type: DELETE_FAILURE,
    errors,
  }
}

// Helper Functions
const handleError = errors => errors || ['Something went wrong']

// Action Creators
export function loadProviderOrderCodes(options){
  return (dispatch) => {
    dispatch(fetchRequest())

    const promise = api('/admin/provider_order_codes.json', options)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.PROVIDER_ORDER_CODE_ARRAY)
        dispatch(updateEntities(normalizedJson))
        dispatch(fetchSuccess())

        return json
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(fetchFailure(errors))
      })

    return promise
  }
}

export function createProviderOrderCode(providerOrderCode, options, callback, errorCallback){
  const config = {
    method: 'POST',
    body: JSON.stringify({
      provider_order_code: providerOrderCode,
    }),
  }
  return (dispatch) => {
    // Set Loading
    dispatch(createRequest())

    const url = `/admin/providers/${providerOrderCode.provider_id}/provider_order_codes.json`
    const promise = api(url, options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.PROVIDER_ORDER_CODE)
        dispatch(updateEntities(normalizedJson))
        dispatch(createSuccess())

        if (callback) callback(json)

        return json
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        if (errorCallback) errorCallback(errors)
        dispatch(createFailure(errors))
      })

    return promise
  }
}

export function deleteProviderOrderCode(providerOrderCode, options){
  const config = {
    method: 'DELETE',
  }

  return (dispatch) => {
    // Set Loading
    dispatch(deleteRequest())

    const { provider_id, id } = providerOrderCode
    const url = `/admin/providers/${provider_id}/provider_order_codes/${id}.json`
    const promise = api(url, options, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok){
          return Promise.reject(json)
        }

        const normalizedJson = normalize(json, Schemas.PROVIDER_ORDER_CODE)
        dispatch(deleteEntity(normalizedJson))
        dispatch(deleteSuccess())

        return json
      })
      .catch((json) => {
        const errors = handleError(json.errors)
        dispatch(deleteFailure(errors))
      })

    return promise
  }
}

// Reducer
export default function reducer(state = initialState, action = {}){
  switch (action.type){
    case FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      })
    case FETCH_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        loaded: true,
        errors: [],
      })
    case FETCH_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        loaded: false,
        errors: action.errors,
      })
    case CREATE_REQUEST:
      return Object.assign({}, state, {
        creating: true,
      })
    case CREATE_SUCCESS:
      return Object.assign({}, state, {
        creating: false,
        result: action.result,
        errors: [],
      })
    case CREATE_FAILURE:
      return Object.assign({}, state, {
        creating: false,
        errors: action.errors,
      })
    case DELETE_REQUEST:
      return Object.assign({}, state, {
        deleting: true,
      })
    case DELETE_SUCCESS:
      return Object.assign({}, state, {
        deleting: false,
        result: action.result || state.result,
        errors: [],
      })
    case DELETE_FAILURE:
      return Object.assign({}, state, {
        deleting: false,
        errors: action.errors,
      })
    default:
      return state
  }
}
